import { cn } from '@/utils'
import type { UpdateKind } from '../types'

const KIND_LABEL: Record<UpdateKind, string> = {
  feature: 'New',
  improvement: 'Improved',
  fix: 'Fixed',
}

const KIND_CLASS: Record<UpdateKind, string> = {
  feature: 'bg-emerald-100 text-emerald-800',
  improvement: 'bg-blue-100 text-blue-800',
  fix: 'bg-amber-100 text-amber-900',
}

export const UpdateKindBadge = ({ kind }: { kind: UpdateKind }) => (
  <span
    className={cn(
      'rounded-full px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wider text-pretty',
      KIND_CLASS[kind],
    )}
  >
    {KIND_LABEL[kind]}
  </span>
)
